import React from 'react';
import {Wizard} from 'react-use-wizard';
import styled from 'styled-components';
import {AnimatePresence} from 'framer-motion';
import {Step1} from './components/steps/step1/Step1';
import {Step2} from './components/steps/step2/Step2';
import {StepIndicator} from './components/step-indicator/StepIndicator';
import {Step3} from './components/steps/step3/Step3';
import backgroundImage from '../../../../assets/images/getStartedBackgroundImage.png';

const WizardContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  background-image: url(${backgroundImage});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;

// Custom wrapper component to control layout without affecting Wizard context
const WizardLayoutWrapper = ({children}: {children: React.ReactNode}) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
      }}>
      <div
        style={{
          flexShrink: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
          paddingTop: '32px',
          paddingBottom: '20px',
        }}>
        <StepIndicator />
      </div>
      <div
        style={{
          flex: 1,
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'auto',
          paddingBottom: '32px',
        }}>
        {children}
      </div>
    </div>
  );
};

export const GetStartedWizard = () => {
  const previousStep = React.useRef<number>(0);

  return (
    <WizardContainer>
      <Wizard
        wrapper={
          <WizardLayoutWrapper>
            <AnimatePresence initial={false} mode="wait" />
          </WizardLayoutWrapper>
        }>
        <Step1 previousStep={previousStep} />
        <Step2 previousStep={previousStep} />
        <Step3 previousStep={previousStep} />
      </Wizard>
    </WizardContainer>
  );
};
